import { ForwardingBatchItemType } from '@ukpostbox/client-data/lib/Types/ForwardingBatchTypes';
import {
	Badge,
	Colour,
	FlexAlign,
	FlexGap,
	FlexJustify,
	Pill,
	PillSize,
	StackHorizontal,
	StackVertical,
} from '@ukpostbox/frontend-framework';
import React, { memo } from 'react';
import { useNavigate } from 'react-router';
import { ForwardingBatchContents } from './Controls/ForwardingBatchItemContents';

const ForwardingBatchGridViewItem = memo((props: ForwardingBatchItemType) => {
	const navigate = useNavigate();
	const statusColour =
		props.statusDescription === 'Forwarded'
			? Colour.Success
			: props.statusDescription === 'Pending'
				? Colour.Warning
				: Colour.Alert;

	return (
		<div
			className={`mailbox-item-block ${statusColour === Colour.Alert ? 'item-row-highlighted' : ''} ${statusColour !== Colour.Alert ? 'item-row-muted' : ''}`}
			data-item-id={props.batchId}
		>
			<div
				tabIndex={0}
				role='button'
				onKeyDown={(e) =>
					e.key === 'Enter' ? navigate(`/mail/forwarding-batches/${props.batchId}`) : undefined
				}
				onClick={() => navigate(`/mail/forwarding-batches/${props.batchId}`)}
				className='mailbox-item-meta'
				draggable={false}
			>
				<div className='mail-item-thumbs-container'>
					{props.files.map((file) => (
						<ForwardingBatchContents {...file} />
					))}
				</div>

				<StackVertical
					align={FlexAlign.Center}
					gap={FlexGap.ExtraSmall}
					justify={FlexJustify.Start}
					extraClass='mail-item-reference'
				>
					<StackHorizontal align={FlexAlign.Center} gap={FlexGap.ExtraSmall}>
						{props.statusDescription === 'attention' && <Badge colour={Colour.Primary} />}

						{statusColour !== Colour.Alert && (
							<span className='mail-item-tracking-id'>{props.batchIdNo}</span>
						)}

						{statusColour === Colour.Alert && (
							<strong className='mail-item-tracking-id'>{props.batchIdNo}</strong>
						)}
					</StackHorizontal>

					<Pill content={props.statusDescription} colour={statusColour} size={PillSize.Small} />
				</StackVertical>
			</div>
		</div>
	);
});

export default ForwardingBatchGridViewItem;
